import { render, staticRenderFns } from "./file_content_linked_field.vue?vue&type=template&id=967d71a0&lang=pug"
import script from "./file_content_linked_field.vue?vue&type=script&lang=js"
export * from "./file_content_linked_field.vue?vue&type=script&lang=js"
import style0 from "./file_content_linked_field.vue?vue&type=style&index=0&id=967d71a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports